import AqilliMaktabLogo from "../../assets/projects/smart_school_icon.png";
import A1CafeLogo from "../../assets/projects/kafe_icon.png";
import A1MenuLogo from "../../assets/projects/menu.png";
import A1MedicalLogo from "../../assets/projects/medical_icon.png";
import A1TaxiLogo from "../../assets/projects/taxi_icon.png";
const projects = [
  {
    name: "SmartSchool",
    type: "Startup",
    date: "2015-01-01",
    description:
      "The application is made in the form of an electronic journal for teachers, an electronic diary for students, general information about children, their health, information about their attendance at school and their anthropometric indicators. In addition, the program provides easy communication between the principal, teacher, parent and child. In this way we can automate educational processes in schools!",
    image: AqilliMaktabLogo,
    orderLink: "https://t.me/A1techbot?start=loyiha_nomi=A1Maktab",
    demoLink: "#",
    interfaceLink: "#",
  },
  {
    name: "A1Kafe",
    type: "Startup",
    date: "2015-01-01",
    description:
      "A1 Cafe is a fully-automated waiter service platform that allows restaurants to increase profits and reduce labor costs. A1 Cafe is a complete solution for businesses with no prior experience in the food industry. The server can receive orders from customers through the local set and notify the chef (kitchen) of the received orders at the same time, and the owner of the cafe can view the daily income and expenses of the cafe, the efficiency of waiters, food calculation, warehouse control reports through a convenient mobile interface. can be controlled through smartphones or tablets.",
    image: A1CafeLogo,
    orderLink: "https://t.me/A1techbot?start=loyiha_nomi=A1Kafe",
    demoLink: "#",
    interfaceLink: "#",
  },
  {
    name: "A1Menu",
    type: "Startup",
    date: "2019-01-01",
    description: "A1Menu is an online menu platform where you can manage your cafe and restaurant menus electronically! This opens up the possibility to display the food in the menu more fully through video, and to advertise your food using your website! Provide your customers with a new approach, a modern menu! Your business deserves it!",
    image: A1MenuLogo,
    orderLink: "https://t.me/A1techbot?start=loyiha_nomi=A1Menu",
    demoLink: "#",
    interfaceLink: "#",
  },
  {
    name: "A1Medical",
    type: "Startup",
    date: "2020-01-01",
    description: "A1Medical is a program aimed at automating the work process in hospitals. The program helps to solve several existing problems, such as queuing problems, red tape, doing the same thing over and over again taking up doctors' time. As a solution to the above problems, the program offers a number of its useful modules, such as electronic queue, online appointment to the doctor, safe storage of data in modern cloud systems and ease of working with data!",
    image: A1MedicalLogo,
    orderLink: "https://t.me/A1techbot?start=loyiha_nomi=A1Medical",
    demoLink: "#",
    interfaceLink: "#",
  },
  {
    name: "A1Taxi",
    type: "Startup",
    date: "2014-01-01",
    description: "A1Taxi is the perfect solution for your taxi business. The program has a separate mobile application for the driver and customers, and these applications have very user-friendly interfaces. Due to the efficient handling of data, you won't encounter freezing, slow performance or other problems in the program. In addition, the program has several important modules for business owners, such as daily income, operator and driver interruptions, employee productivity, bonus and promotion announcements.",
    image: A1TaxiLogo,
    orderLink: "https://t.me/A1techbot?start=loyiha_nomi=A1Taxi",
    demoLink: "#",
    interfaceLink: "#",
  },
];

export default projects;
